import React from 'react';
import Unauthorised from './unauthorised/Unauthorised.jsx';
import GeckoPermissions from '../services/gecko-permissions';
import LoadingIndicator from '../services/loading-indicator';

class Route {
  constructor(config) {
    this.config = config;
  }
  get path() {
    return this.config.path;
  }
  get children() {
    return this.config.children
      ? this.config.children.map((c) => new Route(c))
      : undefined;
  }
  action(...args) {
    if (!this.config.action) {
      return undefined;
    }
    if (this.config.requires) {
      const requiredGroups = this.config.requires.map((req) => {
        if (typeof req === 'function') {
          return req(...args);
        }
        return req;
      });
      const hasAccess = requiredGroups.find(GeckoPermissions.memberOf);
      if (!hasAccess) {
        return {
          route: Object.assign({}, this.config),
          component: <Unauthorised />,
        };
      }
    }
    const actionPromise = new Promise((resolve) => {
      resolve(this.config.action(...args));
    });
    return LoadingIndicator.resolve(actionPromise).then((component) => {
      return {
        route: Object.assign({}, this.config),
        component: component,
      };
    });
  }
}

export default Route;
